/** List pagination constants — default 10 items per page for all tables. */
export const DEFAULT_LIST_PAGE_SIZE = 10;
export const LIST_PAGE_SIZE_OPTIONS = [10, 20, 50] as const;
export type ListPageSize = (typeof LIST_PAGE_SIZE_OPTIONS)[number];

export type PaginateSlice<T> = {
  page: number;
  pageCount: number;
  total: number;
  pageRows: T[];
  rowNumberStart: number;
};

export function slicePage<T>(
  rows: readonly T[],
  page: number,
  pageSize: number,
): PaginateSlice<T> {
  const total = rows.length;
  const pageCount = Math.max(1, Math.ceil(total / Math.max(1, pageSize)));
  const safePage = Math.min(Math.max(1, page), pageCount);
  const start = (safePage - 1) * pageSize;
  return {
    page: safePage,
    pageCount,
    total,
    pageRows: rows.slice(start, start + pageSize) as T[],
    rowNumberStart: total === 0 ? 1 : start + 1,
  };
}
